import { Component, input } from '@angular/core';
import { RidProgressBar } from '../rid-progress-bar/rid-progress-bar';

@Component({
  selector: 'rid-top-bar',
  imports: [RidProgressBar],
  templateUrl: './rid-top-bar.html',
})
export class RidTopBar {
  name = input.required<string>();
  progress = input<number>(0);
  steps = input.required<number>();
}
